// eslint-disable-next-line
// @ts-nocheck
import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Modal,
  Switch,
} from '@mui/material';
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import Iconify from '../../components/Iconify';
import SearchNotFound from '../../components/SearchNotFound';
import { BookingListToolbar } from '../../sections/@dashboard/bookings';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import AllParkingsListHead from '../../sections/@dashboard/bookings/AllParkingsListHead';
import Loading from '../../components/Loading';
import { cities as citiesData } from '../../_mock/bookings';
import { useDeleteCityDataMutation, useGetAllCitiesMutation } from '../../store/api/citiesApi';
import { getCities, getCitiesTotalRecord, setCities } from '../../store/state/citiesSlice';
import {
  useDeleteBlogDetailMutation,
  useFindBlogBySearchMutation,
  useFindBlogDetailByIdMutation,
} from '../../store/api/blogsApi';
import { getBlogs, getBlogsTotalRecord, setBlogs } from '../../store/state/blogsSlice';
import { checkPermissions } from '../../sections/@dashboard/parkingspaces/utility';
import { PERMISSION } from '../../utils/userPermission';
import toast from 'react-hot-toast';


const TABLE_HEAD = [
  { id: ' avatarUrl', alignRight: false },
  { id: 'name', label: 'Title', alignRight: false },
  { id: 'description', label: 'Description', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
];

export default function Blog() {
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem('login') || '{}') || null;
  const dispatch = useAppDispatch();
  const [blogManagementData, setBlogManagementData] = useState([]);
  const [getAllBlogs, BlogResponse] = useFindBlogBySearchMutation();
  const BlogData = useAppSelector(getBlogs);
  const blogTotalRecord = useAppSelector(getBlogsTotalRecord);
  const [findBlogDetailById, deleteResponse] = useDeleteBlogDetailMutation();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('id');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [vendorId, setVendorId] = useState<number>();
  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const filteredUsers = blogManagementData;
  const isUserNotFound = filteredUsers.length === 0;

  useEffect(() => {
    if (BlogData) {
      setBlogManagementData(BlogData);
    }
  }, [BlogData]);

  useEffect(() => {
    getAllBlogs({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        orderBy: order,
      },
    });
    setFilterName('')
  }, []);

  useEffect(() => {
    if (BlogResponse.isSuccess) {
      dispatch(setBlogs(BlogResponse.data));
    }
    if (BlogResponse.isError) {
      let errorData: any = BlogResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [BlogResponse.isSuccess, BlogResponse.isError]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = serviceProviders.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  useEffect(() => {
    if (deleteResponse.isSuccess) {
      getAllBlogs({
        token: token.token,
        payload: {
          offset: rowsPerPage,
          page: page,
          orderBy: order,
        },
      });
      toast.success('Blog updated successfully.');
    }
    if (deleteResponse.isError) {
      let errorData: any = deleteResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [deleteResponse.isSuccess, deleteResponse.isError]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllBlogs({ token: token.token, payload: { offset: rowsPerPage, page: newPage } });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getAllBlogs({ token: token.token, payload: { offset: parseInt(event.target.value, 10), page: 0 } });
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
      getAllBlogs({
        token: token.token,
        payload: { offset: rowsPerPage, page: page, searchValue: event.target.value },
      });
  };

  const handleDelete = () => {
    setOpen(false);
    findBlogDetailById({
      id: vendorId,
      token: token.token,
    });
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const cancelDelete = () => {
    setOpen(false);
  };
  const cancelRequest = () => {};
  const acceptRequest = () => {};

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '10px',
    p: '30px',
    px: '50px',
  };

  return (
    <Page title="Blogs">
      {checkPermissions(PERMISSION.BLOG_ALL, token.permissions) ? (
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" marginBottom={'25px'}>
            <Typography variant="h4" gutterBottom>
              Blogs
            </Typography>
            <Button
              style={{ color: 'white', backgroundColor: '#E23744' }}
              variant="contained"
              onClick={() => {
                navigate('/dashboard/add-or-update-blog', { state: { editMode: false } });
              }}
              startIcon={<Iconify icon="eva:plus-fill" />}
              size="large"
            >
              Add
            </Button>
          </Stack>
          <Card>
            <BookingListToolbar
              numSelected={selected.length}
              filterName={filterName}
              onFilterName={handleFilterByName}
              placeholder={'Search By Title'}
            />
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <AllParkingsListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={blogManagementData.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {filteredUsers.length > 0 &&
                      filteredUsers.map((row) => {
                        const { id, title, description, countryName, imageUrl, status } = row;
                        const isItemSelected = selected.indexOf(name) !== -1;

                        return (
                          <TableRow
                            hover
                            key={id.toString()}
                            tabIndex={-1}
                            role="checkbox"
                            selected={isItemSelected}
                            aria-checked={isItemSelected}
                          >
                            <TableCell align="left">
                              <Avatar alt="Remy Sharp" src={imageUrl} />
                            </TableCell>
                            <TableCell
                              align="left"
                              onClick={() => {
                                navigate('/dashboard/add-or-update-blog', { state: { editMode: true, editData: row } });
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                              <Typography fontWeight="normal" variant="subtitle2" color={'blue'}>
                                {title}
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Typography fontWeight="normal" variant="subtitle2">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: description,
                                  }}
                                />
                              </Typography>
                            </TableCell>
                            <TableCell align="left">
                              <Stack direction="row" alignItems="center">
                                <Switch
                                  checked={status}
                                  onClick={() => {
                                    setVendorId(id);
                                    handleOpen();
                                  }}
                                />
                              </Stack>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>

                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <SearchNotFound searchQuery={filterName} />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={blogTotalRecord || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
          {open && (
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Typography id="modal-modal-title" textAlign={'center'} variant="h4" gutterBottom>
                  Are you sure?
                </Typography>
                <Stack direction="row" justifyContent={'center'} alignItems={'center'}>
                  <Button
                    variant="contained"
                    onClick={cancelDelete}
                    sx={{ margin: '10px' }}
                    style={{ color: 'white', backgroundColor: '#E23744' }}
                  >
                    No
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleDelete}
                    sx={{ margin: '10px' }}
                    style={{ color: 'white', backgroundColor: '#E23744' }}
                  >
                    Yes
                  </Button>
                </Stack>
              </Box>
            </Modal>
          )}

          {BlogResponse.isLoading ? <Loading /> : null}
        </Container>
      ) : null}
    </Page>
  );
}
